<template>
  <div>
    <div class="title-popup-s ">{{ title }}</div>
      <el-select class="time" v-model="timeInfo.hour" placeholder="시" @change="changeTimeInfoSelection">
        <el-option class="ie-select" v-for="time in TIME" :key="time.time" :label="time.label" :value="time.time" />
      </el-select>
      <span>시</span>
      <el-select class="time" v-model="timeInfo.minute" placeholder="분" @change="changeTimeInfoSelection">
        <el-option class="ie-select" v-for="min in MINUTE" :key="min.minute" :label="min.label" :value="min.minute" />
      </el-select>
      <span>분</span>
    <!-- </div> -->
  </div>
</template>
<script>
import { TIME, MINUTE } from '@/constants/date';

export default {
  name: 'WAmsTimeSelectionComponent',
  props: {
    title: String,
    executeHour: Number,
    executeMinute: Number,
    isOnceTimeInfo: Boolean,
  },
  data() {
    return {
      TIME,
      MINUTE,
      timeInfo: {
        hour: 0,
        minute: 0,
      },
    };
  },
  watch: {
    executeHour: {
      handler(hour) {
        this.timeInfo.hour = hour;
      },
      immediate: true,
    },
    executeMinute: {
      handler(minute) {
        this.timeInfo.minute = minute;
      },
      immediate: true,
    },
  },
  methods: {
    init() {
      this.timeInfo.hour = 0;
      this.timeInfo.minute = 0;
    },
    getSelectionTime() {
      return {
        hour: this.timeInfo.hour,
        minute: this.timeInfo.minute,
      };
    },
    /**
     * 자동화 태스크 설정 시 '한번만'을 선택하는 경우에 한해서 선택한 time 정보를 emit
     * @author yelim
     */
    changeTimeInfoSelection() {
      if (this.isOnceTimeInfo === true) {
        this.$emit('change-time-info', this.timeInfo);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.time {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/server/AmsSettings/TriggerSetting/components/AmsTimeSelectionComponent.vue